const ISO_RE = /^\d{4}-\d{2}-\d{2}$/;
export const pinDate = (d) => (ISO_RE.test(d || "") ? d : null);

function parseTime(t) {
  const m = /(\d{1,2})(?::(\d{2}))?\s*([AaPp])[Mm]/.exec(t || "");
  if (!m) return null;
  let h = parseInt(m[1], 10) % 12;
  if (m[3].toUpperCase() === "P") h += 12;
  return { h, min: parseInt(m[2] || "0", 10) };
}

const esc = (s) =>
  String(s || "").replace(/\\/g, "\\\\").replace(/;/g, "\\;").replace(/,/g, "\\,").replace(/\n/g, "\\n");

const pad = (n) => String(n).padStart(2, "0");
const dateStamp = (y, mo, d) => `${y}${pad(mo)}${pad(d)}`;
const timeStamp = (y, mo, d, h, mi) => `${dateStamp(y, mo, d)}T${pad(h)}${pad(mi)}00`;

// Builds and downloads an .ics calendar file (opens in Apple Calendar, Google Calendar, Outlook)
export function downloadIcs(e) {
  const day = pinDate(e.date);
  if (!day) return false;
  const [y, mo, d] = day.split("-").map(Number);
  const t = parseTime(e.time);

  const lines = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Victory Chapel Christian Church//VC Clay Events//EN",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${String(e.id || `${day}-${e.title}`).replace(/\s/g, "")}@vcclaychurch.com`,
  ];
  if (t) {
    const end = new Date(y, mo - 1, d, t.h + 2, t.min);
    lines.push(`DTSTART:${timeStamp(y, mo, d, t.h, t.min)}`);
    lines.push(`DTEND:${timeStamp(end.getFullYear(), end.getMonth() + 1, end.getDate(), end.getHours(), end.getMinutes())}`);
  } else {
    lines.push(`DTSTART;VALUE=DATE:${dateStamp(y, mo, d)}`);
  }
  if (e.recurring) lines.push("RRULE:FREQ=WEEKLY");
  lines.push(`SUMMARY:${esc(e.title)}`);
  if (e.location) lines.push(`LOCATION:${esc(e.location)}`);
  if (e.description) lines.push(`DESCRIPTION:${esc(e.description)}`);
  lines.push("END:VEVENT", "END:VCALENDAR");

  const blob = new Blob([lines.join("\r\n")], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${(e.title || "event").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return true;
}
